import moment from "moment";

const DATE_FORMATS = [moment.ISO_8601, "YYYY-MM-DD HH:mm:ss", "YYYY-MM-DD"];

const parseFecha = (value) => {
    if (!value) return null;
    const parsed = moment(value, DATE_FORMATS);
    return parsed.isValid() ? parsed.startOf("day") : null;
};

export const isReservaFutura = (row) => {
    const desde = parseFecha(row?.fechaDesde);
    if (!desde) return false;
    return desde.isAfter(moment().startOf("day"));
};

export const terminaHoy = (row) => {
    const hasta = parseFecha(row?.fechaHasta);
    if (!hasta) return false;
    return hasta.isSame(moment().startOf("day"));
};

export const isReservaCancelable = (row) =>
    row?.reservaStatusCode === "R" &&
    isReservaFutura(row);

export const isCambioHabitacionDisponible = (row) =>
    (row?.reservaStatusCode === "R" || row?.reservaStatusCode === "I") &&
    !terminaHoy(row);

export const isCheckoutDisponible = (row) => {
    // Verificar que la reserva esté activa (en ocupación)
    const esActiva = row?.reservaStatusCode === "I";
    if (!esActiva) return false;

    const hasta = parseFecha(row?.fechaHasta);
    if (!hasta) return false;

    const ahora = moment();
    const hoyStartOfDay = moment().startOf("day");

    // Si la fecha de checkout es anterior a hoy, permitir checkout
    if (hasta.isBefore(hoyStartOfDay)) return true;

    // Si la fecha de checkout es hoy, verificar que la hora de checkout ya pasó
    if (hasta.isSame(hoyStartOfDay, "day")) {
        const checkoutTime = row?.SFHotelCheckout;
        if (!checkoutTime) return false; // Sin hora de checkout, no permitir

        // Parsear la hora de checkout (formato esperado: "HH:mm")
        const checkoutMoment = moment(checkoutTime, ["HH:mm", "HH:mm:ss"]);
        if (!checkoutMoment.isValid()) return false;

        // Establecer la hora de checkout en el día de hoy
        const checkoutHoyMoment = moment()
            .hour(checkoutMoment.hour())
            .minute(checkoutMoment.minute())
            .second(0);

        // Permitir checkout si la hora actual ya pasó la hora de checkout
        return ahora.isAfter(checkoutHoyMoment) || ahora.isSame(checkoutHoyMoment);
    }

    return false;
};

